/*
* Copyright 2026 Tecnalia, Basque Research & Technology Alliance (BRTA)
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*
*  SPDX-License-Identifier: Apache-2.0
*/

import { RoleService } from 'app/core/services/role/role.service';
import { AuthService } from 'app/auth/services/auth.service';
import { TranslateModule } from '@ngx-translate/core';
import { Component } from '@angular/core';

@Component({
    selector: 'app-role',
    standalone: true,
    imports: [ TranslateModule ],
    templateUrl: './role.component.html',
    styleUrl: './role.component.scss'
})

export class RoleComponent {

	role: string = '';

	isAdmin: boolean = false;

	constructor(
		private roleService: RoleService,
		private authService: AuthService
	) {
		this.roleService.currentRole$.subscribe(role => {
			this.role = role;
		});
		this.isAdmin = this.isAdministrator();
	}

	private isAdministrator(): boolean {
		const roles: string[] = this.authService.getRealmRoles();
		return roles.includes('ds-catalog-administrator');
	}

	getVisibleCardsCount(): number {
		let count = 1;
		if (this.isAdmin) count++;
		return count || 1;
	}

}